import React, { useState, useEffect } from "react";
import "./styles/ExtraButtons.css";
import axios from "axios";

const ExtraButtons = ({ selectedBrand, data, harness_IP_address }) => {
  const [buttonGroups, setButtonGroups] = useState([{}]);
  const [message, setMessage] = useState("");

  const handleSendButtonClick = async (groupIndex) => {
    const buttonSelect = buttonGroups[groupIndex]?.selectedButton;

    if (selectedBrand && buttonSelect) {
      // const brandWithoutLirc = selectedBrand.replace("_lirc", "");
      const selectedBrandKey = `${selectedBrand}_lirc`;
      const buttonValue = data[selectedBrandKey][buttonSelect];

      const url = `v1/send_ir/${selectedBrand}/${buttonValue}`;
      try {
        const { data } = await axios.get(`/${url}`);

        console.log(data);
        setMessage(`Success: Button ${buttonValue}.`);
      } catch (error) {
        console.log(error);
        setMessage(`FAILED: Button ${buttonValue}.`);
      }
    } else {
      setMessage("Error: Please select a button first.");
    }
  };

  const addButtonGroup = () => {
    setButtonGroups([...buttonGroups, {}]);
  };

  const removeButtonGroup = () => {
    if (buttonGroups.length > 1) {
      setButtonGroups(buttonGroups.slice(0, -1));
    }
  };

  const populateButtons = (index) => {
    const selectedBrandKey = `${selectedBrand}_lirc`;
    const selectedBrandData = data[selectedBrandKey];

    if (!selectedBrandData) {
      console.error(`Key ${selectedBrandKey} not found in data`);
      return [];
    }

    return Object.keys(selectedBrandData)
      .filter((key) => key.startsWith("button_") && !key.includes("_times"))
      .map((button) => {
        const matchResult = button.match(/\d+/); // Check if match is successful
        const buttonNumber = matchResult ? matchResult[0] : null;

        if (!buttonNumber) {
          console.error(`Invalid button key: ${button}`);
          return null; // Skip invalid buttons
        }

        const timesKey = `button_${buttonNumber}_times`;
        const buttonValue = selectedBrandData[button];

        return {
          value: button,
          label: `${button}: "${buttonValue}" (${selectedBrandData[timesKey]} times)`,
        };
      })
      .filter(Boolean); // Remove any `null` entries
  };

  const handleButtonSelectChange = (index, value) => {
    const updatedGroups = [...buttonGroups];
    updatedGroups[index] = {
      ...updatedGroups[index],
      selectedButton: value,
    };
    setButtonGroups(updatedGroups);
  };

  return (
    <div className="extra-buttons-container">
      <h5 className="extra-buttons-title">Add extra buttons</h5>

      {buttonGroups.map((group, index) => (
        <div key={index} className="extra-buttons-group">
          <label className="extra-buttons-label">Select Button:</label>
          <div className="extra-buttons-control">
            <select
              className="extra-buttons-select"
              value={group.selectedButton || ""}
              onChange={(e) => handleButtonSelectChange(index, e.target.value)}
              disabled={!selectedBrand}
            >
              <option value="">Choose a button</option>
              {populateButtons(index).map((button) => (
                <option key={button.value} value={button.value}>
                  {button.label}
                </option>
              ))}
            </select>
            <button
              className="extra-buttons-send"
              onClick={() => {
                console.log(`the index is ${index}`);

                handleSendButtonClick(index);
              }}
              disabled={!group.selectedButton}
            >
              Send
            </button>
          </div>
        </div>
      ))}

      <div className="extra-buttons-actions">
        <button className="extra-buttons-add" onClick={addButtonGroup}>
          +
        </button>
        <button className="extra-buttons-remove" onClick={removeButtonGroup}>
          -
        </button>
      </div>

      <p className="extra-buttons-message">{message}</p>
    </div>
  );
};

export default ExtraButtons;
